import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  formMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  inputList: {
    '& .MuiInputBase-root': {
      height: 'auto',
    },
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
  formLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '380px',
  },
  formInput: {
    color: colors.black,
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
  },
  formBaseInput: {
    '& .MuiFormHelperText-root': {
      color: colors.gray,
    },
  },
  footer: {
    '& > button': {
      marginLeft: '6px',
    },
  },
});

export default useStyles;
